import { Link } from "react-router-dom";
import { featuredContent } from "@/mocks/home";

export default function FeaturedSection() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            特别推荐
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            精选优质综艺内容，发现更多精彩节目
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6" data-product-shop="">
          {featuredContent.map((show) => (
            <Link
              key={show.id}
              to={`/article/${show.id}`}
              className="group relative rounded-xl overflow-hidden cursor-pointer no-underline h-[280px] md:h-[340px]"
            >
              <img
                src={show.image}
                alt={show.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                title={`${show.title} - 6789影视`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>

              <div className="absolute top-4 left-4">
                <span className="px-3 py-1 rounded-full text-xs font-semibold bg-accent-500 text-white">
                  {show.badgeText}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6">
                <span className="text-xs text-primary-300 font-medium mb-2 block">
                  {show.category}
                </span>
                <h3 className="text-xl md:text-2xl font-heading text-white mb-2 group-hover:text-primary-300 transition-colors">
                  {show.title}
                </h3>
                <p className="text-sm text-white/70 line-clamp-2">
                  {show.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}